import React from 'react';
import moment from 'moment';
import { I18n } from '@aws-amplify/core';
import { ColumnsType } from 'antd/lib/table';
import type { ReportData } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/types';
import * as S from '@/components/Settings/DataExtraction/styles';

function formatRpn(value: ReportData['rpn']): string {
	if (value === null || value === undefined || value === '') {
		return '-';
	}

	const parsed = Number(value);

	if (Number.isFinite(parsed)) {
		return String(Math.trunc(parsed)).slice(0, 3);
	}

	return String(value).slice(0, 3);
}

function renderLeftAlignedText(value?: string | null): JSX.Element {
	return (
		<div
			style={{
				textAlign: 'left',
				width: '100%',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap'
			}}
		>
			{value || '-'}
		</div>
	);
}

export function tableColumns(): ColumnsType<ReportData> {
	return [
		{
			title: <S.LabelMediumSemibold>{I18n.get('Report')}</S.LabelMediumSemibold>,
			dataIndex: 'acronym',
			key: 'acronym',
			align: 'center',
			width: 96,
			ellipsis: true,
			responsive: ['sm']
		},
		{
			title: <S.LabelMediumSemibold>{I18n.get('Name')}</S.LabelMediumSemibold>,
			dataIndex: 'name',
			key: 'name',
			align: 'center',
			width: '34%',
			responsive: ['sm'],
			ellipsis: true,
			render: (value: string | null) => renderLeftAlignedText(value)
		},
		{
			title: <S.LabelMediumSemibold>{I18n.get('Workstation')}</S.LabelMediumSemibold>,
			dataIndex: 'workstation',
			key: 'workstation',
			align: 'center',
			width: '28%',
			ellipsis: true,
			responsive: ['xl'],
			render: (value: string | null) => renderLeftAlignedText(value)
		},
		{
			title: <S.LabelMediumSemibold>{I18n.get('RPN')}</S.LabelMediumSemibold>,
			dataIndex: 'rpn',
			key: 'rpn',
			align: 'center',
			width: 88,
			ellipsis: true,
			responsive: ['sm'],
			render: (value: ReportData['rpn']) => formatRpn(value)
		},
		{
			title: <S.LabelMediumSemibold>{I18n.get('Creation date')}</S.LabelMediumSemibold>,
			dataIndex: 'created_at',
			key: 'created_at',
			align: 'center',
			width: 128,
			ellipsis: true,
			responsive: ['sm'],
			render: (date: string) => (date ? moment(date).format('DD/MM/YYYY') : '-')
		}
	];
}
